var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection2Icon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_346)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_50_346)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_50_346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48792 2.75H3.90492C3.66171 2.75 3.42847 2.84661 3.2565 3.01858C3.08453 3.19055 2.98792 3.4238 2.98792 3.667V8.25C2.98792 8.756 3.39792 9.167 3.90492 9.167H8.48792C8.99392 9.167 9.40491 8.757 9.40491 8.25V3.667C9.40491 3.4238 9.3083 3.19055 9.13633 3.01858C8.96436 2.84661 8.73112 2.75 8.48792 2.75ZM8.48792 12.833H3.90492C3.66171 12.833 3.42847 12.9296 3.2565 13.1016C3.08453 13.2736 2.98792 13.5068 2.98792 13.75V18.333C2.98792 18.839 3.39792 19.25 3.90492 19.25H8.48792C8.99392 19.25 9.40491 18.84 9.40491 18.333V13.75C9.40491 13.5068 9.3083 13.2736 9.13633 13.1016C8.96436 12.9296 8.73112 12.833 8.48792 12.833ZM18.5699 2.75H13.9869C13.7437 2.75 13.5105 2.84661 13.3385 3.01858C13.1665 3.19055 13.0699 3.4238 13.0699 3.667V8.25C13.0699 8.756 13.4799 9.167 13.9869 9.167H18.5699C19.0759 9.167 19.4869 8.757 19.4869 8.25V3.667C19.4869 3.4238 19.3903 3.19055 19.2183 3.01858C19.0464 2.84661 18.8131 2.75 18.5699 2.75ZM18.5699 12.833H13.9869C13.7437 12.833 13.5105 12.9296 13.3385 13.1016C13.1665 13.2736 13.0699 13.5068 13.0699 13.75V18.333C13.0699 18.839 13.4799 19.25 13.9869 19.25H18.5699C19.0759 19.25 19.4869 18.84 19.4869 18.333V13.75C19.4869 13.5068 19.3903 13.2736 19.2183 13.1016C19.0464 12.9296 18.8131 12.833 18.5699 12.833Z",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.40979)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_50_346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.40979)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_50_346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.40979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2Icon3);
export default __webpack_public_path__ + "static/media/section2_icon3.f86906fe88be80026d2638655d19d379.svg";
export { ForwardRef as ReactComponent };